import { createAction, props } from '@ngrx/store';
import { QuoteRequest, QuoteResponse, QuoteApplicationsPage } from '../../models/quote.model';

export const submitQuoteApplication = createAction(
  '[Quote] Submit Application',
  props<{ data: QuoteRequest }>()
);

export const submitQuoteApplicationSuccess = createAction(
  '[Quote] Submit Application Success',
  props<{ application: QuoteResponse }>()
);

export const submitQuoteApplicationFailure = createAction(
  '[Quote] Submit Application Failure',
  props<{ error: string }>()
);

export const getQuoteApplications = createAction(
  '[Quote] Get Applications',
  props<{ pageNumber?: number; pageSize?: number }>()
);

export const getQuoteApplicationsSuccess = createAction(
  '[Quote] Get Applications Success',
  props<{ page: QuoteApplicationsPage }>()
);

export const getQuoteApplicationsFailure = createAction(
  '[Quote] Get Applications Failure',
  props<{ error: string }>()
);

export const getQuoteApplicationById = createAction(
  '[Quote] Get Application By Id',
  props<{ id: number }>()
);

export const getQuoteApplicationByIdSuccess = createAction(
  '[Quote] Get Application By Id Success',
  props<{ application: QuoteResponse }>()
);

export const getQuoteApplicationByIdFailure = createAction(
  '[Quote] Get Application By Id Failure',
  props<{ error: string }>()
);

export const resetQuoteState = createAction('[Quote] Reset State');